import { PointerLockControls } from "@controllers/controls";
import { Button, Container, Heading } from "@gui/components";
import * as sharedStyles from "../css/Shared.module.css";
const PauseHome = props => {
    const toggleSettings = () => {
        props.goToSettings();
    };
    const resume = () => {
        const controls = PointerLockControls.getInstance();
        controls.lock();
    };
    return (<Container>
            <Heading class={sharedStyles.shared_heading}>Game paused</Heading>
            <Button name="resumeGame" onClick={resume}>
                Resume
            </Button>
            <Button name="settings" onClick={toggleSettings}>
                Settings
            </Button>
        </Container>);
};
export default PauseHome;
